import config from '@/config';
import {ApiBase, InternationalizedField} from '@/api/common';
import Hint from '@/api/hint';

const NO_UPLOAD_FIELDS = [
    'state',
    'hints', // TODO remove
];

export default class StressMarker extends ApiBase<StressMarker> {
    public static readonly SLUG: string = 'exercise-speaking-stress-marker';
    private static readonly URL_BASE: string = config.API_ROOT + '/exercise-speaking-stress-marker/';
    
    // Initializing these fields (even with undefined)
    // is necessary, so hasOwnAttribute can find them.
    public start_index?: number = undefined;
    public end_index?: number = undefined;
    public word_start_index?: number = undefined;
    public word_end_index?: number = undefined;
    public score_type?: string = undefined;
    public order?: number = undefined;
    public parent_exercise?: number = undefined;
    
    public hints: InternationalizedField<Hint[]> = new InternationalizedField<Hint[]>();
    
    // currently unused
    public spreadsheet?: string = undefined;
    
    // used to know if the hint is being created, was updated or is saved
    public state?: string = 'created';

    public prominence?: string = undefined;
    public duration?: string = undefined;
    
    public constructor() {
        super({
            urlBase: StressMarker.URL_BASE,
            filteredFields: NO_UPLOAD_FIELDS,
        });
    }
    
    public assign(response: any): StressMarker {
        super.assign(response);
        
        if (response && 'hints' in response) {
            this.hints = new InternationalizedField<Hint[]>(response.hints);
        }
        
        this.state = 'unchanged';
        return this;
    }
}
